import {
    GdCampaignBudgetPeriod,
    GdCampaignBudgetShowMode,
    GdWalletBudgetShowMode,
    GdWalletBudgetType
} from './graphql-grid';

export interface WalletDayBudgetValue {
    type: GdWalletBudgetType;
    sum?: number;
    mode?: GdWalletBudgetShowMode;
}

export enum BudgetType {
    day = 'day',
    week = 'week',
    custom = 'custom'
}

export interface DayBudgetValue {
    type: BudgetType.day;
    isActive: boolean;
    sum: number;
    mode: GdCampaignBudgetShowMode;
}

export interface RawDayBudgetValue {
    isActive: boolean;
    sum: string;
    mode: GdCampaignBudgetShowMode;
}

export interface WeekBudgetValue {
    type: BudgetType.week;
    sum?: number;
}

export interface CustomPeriodBudgetValue {
    type: BudgetType.custom;
    sum?: number;
    start?: string;
    finish?: string;
}

export type BudgetValue = DayBudgetValue | WeekBudgetValue | CustomPeriodBudgetValue;

export interface CampaignStrategyBudgetInfo {
    type: GdCampaignBudgetPeriod | null;
    value?: BudgetValue;
}

export interface CampaignDayBudgetParams {
    campaignId: string;
    value?: DayBudgetValue;
}

export const isDayBudget = (budget?: BudgetValue): budget is DayBudgetValue =>
    budget !== undefined && budget.type === BudgetType.day;
